import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DeviceService } from '../../../services/device.service';
import { ToastrService } from 'ngx-toastr';
import { FormsModule, NgForm } from '@angular/forms';
import { User } from '../../../models/user.model';
import { ConfirmServiceService } from '../../confirm-dialog/confirm-service.service';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { Country } from 'country-state-city';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { UserRoleEnum } from '../../../enums/user-role-enum';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';

import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

declare var $: any;
@Component({
  selector: 'app-add-delete-device',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, BsDatepickerModule],
  templateUrl: './add-delete-device.component.html',
  styleUrl: './add-delete-device.component.css',
})
export class AddDeleteDeviceComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;
  addDeviceForm!: FormGroup;
  createGroup!: FormGroup;
  categories: Array<any> = [];
  usageType: Array<any> = [];
  zone: any;
  deviceType: any;
  consumerID: string = '';
  deviceIDs: string = '';
  selectedZone: string = '';
  isFileValid: boolean = false;
  fileErrorMessage: string | null = null;
  consumerIDs: string[] = [];
  groupName: string = '';
  searchKey: string = '';
  searchTermInvalid: boolean = false;
  countryCodes: Array<{ code: string; name: string; dial_code: string }> = [];
  defaultCountryCode: String = environment.DefaultCountryCode;
  selectedGroup: string = '';
  matchingConsumerIDs: string[] = [];
  loggedUser: User = new User();
  isUser: boolean = false;
  validToken: boolean = false;
  functionName: string = '';
  addEditDeviceBody: any;
  projectMangerId: any;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('modalRef', { static: false }) modalRef!: ElementRef;
  addDeviceHeaderText: String = 'Add Device';
  addDeviceBlockSubmitText: String = 'Submit';

  // private passwordComponentRef!: ComponentRef<VerifySecurityTokenComponent>;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private fb: FormBuilder,
    private deviceService: DeviceService,
    private toastr: ToastrService,
    private readonly confirmServiceService: ConfirmServiceService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.datePickerConfig = {
      dateInputFormat: 'DD/MM/YYYY',
    };
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    if (this.loggedUser.role === UserRoleEnum.User) {
      this.isUser = true;
    }
    this.validateForm();
    this.getUsageType();
    this.getdeviceZone();
    this.getdeviceType();
    this.loadAllCountryCode();
  }
  ngAfterViewInit(): void {
    // Log to verify modal reference
    //console.log('Modal element:', this.modalRef?.nativeElement);
  }

  validateForm() {
    this.addDeviceForm = this.fb.group({
      id: [''],
      consumerId: ['', [Validators.required, this.noWhitespaceValidator()]],
      group: ['', Validators.required],
      deviceType: ['', Validators.required],
      devUi: ['', [Validators.required, this.noWhitespaceValidator()]],
      ConsumerName: ['', [Validators.required, this.noWhitespaceValidator()]],
      countryCode: ['', Validators.required],
      ConsumerPhone: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
      ],
      consumerAddress: [
        '',
        [Validators.required, this.noWhitespaceValidator()],
      ],
      latitude: [
        '',
        [
          Validators.required,
          Validators.pattern(/^-?\d+(\.\d+)?$/),
          Validators.min(-90),
          Validators.max(90),
        ],
      ],
      longitude: [
        '',
        [
          Validators.required,
          Validators.pattern(/^-?\d+(\.\d+)?$/),
          Validators.min(-180),
          Validators.max(180),
        ],
      ],
      commissiondate: ['', Validators.required],
      usageType: ['', Validators.required],
    });

    this.createGroup = this.fb.group({
      groupName: ['', [Validators.required, this.noWhitespaceValidator()]],
    });
  }

  getControl(controlName: string) {
    return this.addDeviceForm.get(controlName);
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      if (value.trim().length === 0) {
        return { whitespace: true };
      }
      return null;
    };
  }

  onSubmitAddDevice() {
    if (this.addDeviceForm.valid) {
      this.trimFormValues(this.addDeviceForm);
      let countryCode = this.addDeviceForm.get('countryCode')?.value;
      // if (!countryCode.startsWith('+')) {
      //   countryCode = '+' + countryCode;
      // }
      const consumerPhone = this.addDeviceForm.get('ConsumerPhone')?.value;
      const phoneNumber = `${countryCode},${consumerPhone}`;
      const deviceData = {
        ...this.addDeviceForm.value,
        phoneNumber,
      };
      if (this.isUser) {
        $('#securityTokenConfirmation').modal('show');
        this.functionName = 'addupdatedevice';
        this.addEditDeviceBody = deviceData;
      } else {
        this.addUpdateDevice(deviceData);
      }
    } else {
      this.addDeviceForm.markAllAsTouched();
    }
  }
  addUpdateDevice(deviceData: any) {
    this.spinner.show();
    this.deviceService.addDevice(deviceData).subscribe(
      (response: any) => {
        this.toastr.success(response.message, 'Add/Modify Devices');
        this.addDeviceForm.reset();
        this.searchKey = '';
        this.addDeviceBlockSubmitText = 'Submit';
        this.addDeviceHeaderText = 'Add Device';
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
        console.log(err.error);
        let errorMessage =
          typeof err.error.message === 'object'
            ? err.error.message.Text
            : err.error.message;
        this.toastr.error(errorMessage, 'Add/Modify Devices');
      }
    );
  }
  trimFormValues(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control && control.value && typeof control.value === 'string') {
        control.setValue(control.value.trim());
      }
    });
  }

  getdeviceType() {
    this.deviceService.getdeviceType().subscribe(
      (response) => {
        this.deviceType = response.data.deviceType;
      },
      (error) => {
        console.error('Failed to fetch device category', error);
      }
    );
  }

  getUsageType() {
    this.deviceService.getUsageType().subscribe(
      (response) => {
        this.usageType = response.data.usageType;
      },
      (error) => {
        console.error('Failed to fetch usage type', error);
      }
    );
  }

  getdeviceZone() {
    this.deviceService.getdeviceZone().subscribe(
      (response) => {
        this.zone = response.data.zone;
      },
      (error) => {
        console.error('Failed to fetch device zone', error);
      }
    );
  }

  getDevice(isConsumerId: any) {
    this.consumerID = this.consumerID.trim();
    if (this.consumerID) {
      this.matchingConsumerIDs = [];
      this.deviceService.getDeviceByConsumerID(this.consumerID).subscribe(
        (response) => {
          if (response.data && response.data.device) {
            const devices = response.data.device;
            this.deviceIDs = devices
              .map((device: { dev_eui: string | null }) => device.dev_eui)
              .filter((dev_eui: string | null) => !!dev_eui)
              .join(', ');
          } else {
            this.deviceIDs = '';
          }
        },

        (error) => {
          console.error('Device not found', error);
          this.deviceIDs = '';
          let errorMessage =
            typeof error.error.message === 'object'
              ? error.error.message.Text
              : error.error.message;
          this.toastr.error(errorMessage, 'Add/Delete Devices');
        }
      );
    } else {
      isConsumerId.control.markAsTouched();
    }
  }

  deleteDeviceConfirmation(isConsumerId: any) {
    this.confirmServiceService.showConfirm(
      `Are you sure you want to delete?`,
      () => {
        if (this.isUser) {
          $('#securityTokenConfirmation').modal('show');
          this.functionName = 'deleteDevice';
          this.addEditDeviceBody = isConsumerId;
        } else {
          this.deleteDevice(isConsumerId);
        }
      },
      () => {}
    );
  }

  deleteDevice(isConsumerId: any) {
    if (this.deviceIDs) {
      this.spinner.show();
      this.deviceService.deleteDevice(this.deviceIDs).subscribe(
        (response) => {
          this.toastr.success(
            'Device deleted successfully.',
            'Add/Delete Devices'
          );
          this.resetForm(isConsumerId);
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.error('Error deleting device', error);
          this.toastr.error('Failed to delete device.', 'Add/Delete Devices');
          this.resetForm(isConsumerId);
        }
      );
    }
  }

  resetForm(isConsumerId?: any) {
    this.consumerID = '';
    this.deviceIDs = '';

    if (isConsumerId) {
      isConsumerId.control.reset();
      isConsumerId.control.markAsUntouched();
    }
  }

  deleteDeviceByZone(zoneSelect: any) {
    if (this.selectedZone) {
      this.confirmServiceService.showConfirm(
        `Are you sure you want to delete?`,
        () => {
          if (this.isUser) {
            $('#securityTokenConfirmation').modal('show');
            this.functionName = 'deleteDEviceByZone';
            this.addEditDeviceBody = zoneSelect;
          } else {
            this.addEditDeviceBody = zoneSelect;
            this.deleteDEviceByZoneFUnction();
          }
        },
        () => {}
      );
    } else {
      zoneSelect.control.markAsTouched();
    }
  }
  deleteDEviceByZoneFUnction() {
    this.spinner.show();
    this.deviceService.deleteDeviceByZone(this.selectedZone).subscribe(
      (response) => {
        this.toastr.success(response.message, 'Add/Delete Devices');
        this.resetForm();
        this.selectedZone = '';
        this.addEditDeviceBody.control.markAsUntouched();
        this.getdeviceZone();
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.error('Error', error);
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Add/Delete Devices');
        this.resetForm();
      }
    );
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    const allowedExtensions = ['xlsx', 'xls', 'csv'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.fileErrorMessage =
        'Invalid file type. Please select an Excel/csv file.';
      this.isFileValid = false;
    } else {
      this.fileErrorMessage = null;
      this.isFileValid = true;
    }

    if (file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const data = new Uint8Array(reader.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        this.consumerIDs = jsonData
          .slice(1)
          .map((row: any) => row[0])
          .filter((id: string) => id);
      };
    }
  }

  async deleteDeviceByFileUpload() {
    if (!this.isFileValid) {
      this.fileErrorMessage = 'Please upload a file.';
      return;
    }
    if (this.consumerIDs.length > 0) {
      const count = await this.getActiveAndInactiveDeviceCount(
        this.consumerIDs
      );
      this.confirmServiceService.showConfirm(
        `${count.Active} device(s) from the ${count.Total} device(s) uploaded are active. Are you sure you want to delete the active devices?`,
        () => {
          if (this.isUser) {
            $('#securityTokenConfirmation').modal('show');
            this.functionName = 'deleteDeviceByFile';
            this.addEditDeviceBody = '';
          } else {
            this.deleteDeviceByFileFuncion();
          }
        },
        () => {}
      );
    } else {
      this.fileErrorMessage = 'No consumer Id found.';
      this.isFileValid = false;
      return;
    }
  }
  deleteDeviceByFileFuncion() {
    this.spinner.show();
    this.deviceService.deleteDeviceByFileUpload(this.consumerIDs).subscribe(
      (response) => {
        this.toastr.success(
          'Device deleted successfully.',
          'Add/Delete Devices'
        );
        this.fileInput.nativeElement.value = '';
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.error('Error', error);
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Add/Delete Devices');
        this.fileInput.nativeElement.value = '';
      }
    );
  }
  getActiveAndInactiveDeviceCount(consumerIDs: any): Promise<any> {
    return this.deviceService
      .getFileUploadDeviceCount(consumerIDs)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error fetching device count:', error);
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Add/Delete Devices');
      });
  }

  downloadSampleFile() {
    this.deviceService.downloadFile().subscribe(
      (response) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'floindex-sample-file.xlsx';
        a.click();
      },
      (error) => {
        console.error('Error downloading the file:', error);
      }
    );
  }

  createNewGroup() {
    if (this.createGroup.valid) {
      this.spinner.show();
      let groupName = this.createGroup.get('groupName')?.value.trim();
      this.deviceService.createGroup(groupName).subscribe(
        (response) => {
          this.spinner.hide();
          this.toastr.success(
            'Group created successfully',
            'Add/Delete Devices'
          );
          this.getdeviceZone();
          let newGroup = response.data.getCreatedGroup;
          const groupId = newGroup.id;
          this.selectedGroup = groupId;
          this.closeModal();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          let errorMessage =
            typeof error.error.message === 'object'
              ? error.error.message.Text
              : error.error.message;
          this.toastr.error(errorMessage, 'Add/Delete Devices');
        }
      );
    } else {
      this.createGroup.markAllAsTouched();
    }
  }
  closeModal() {
    $('#createGroupModel').modal('hide');
    this.createGroup.reset();
  }

  getDeviceByNameOrId(searchKey: string) {
    let searchkey = searchKey.trim();

    if (searchkey) {
      this.searchTermInvalid = false;

      this.deviceService.searchDeviceByNameOrId(searchkey).subscribe(
        (response) => {
          let data = response.data.deviceDetails;
          const commissionDate = new Date(data.commission_date);
          const formattedDate = this.formatDateForInput(commissionDate);
          const consumer_phone = data.consumer_phone;
          let countryCode;
          let phoneNumber;
          if (consumer_phone) {
            [countryCode, phoneNumber] = consumer_phone.split(',');
          }

          this.addDeviceForm.patchValue({
            id: data.id,
            consumerId: data.consumer_id,
            group: data.zone_id,
            deviceType: data.device_type,
            devUi: data.dev_eui,
            usageType: data.usage_type,
            ConsumerName: data.consumer_name,
            consumerAddress: data.consumer_address,
            commissiondate: formattedDate,
            latitude: data.location.latitude,
            longitude: data.location.longitude,
            ConsumerPhone: phoneNumber || '',
            countryCode: countryCode || '',
          });
          this.addDeviceHeaderText = 'Modify Device';
          this.addDeviceBlockSubmitText = 'Modify';
        },
        (error) => {
          this.addDeviceForm.reset();
          let errorMessage =
            typeof error.error.message === 'object'
              ? error.error.message.Text
              : error.error.message;
          this.toastr.error(errorMessage, 'Add/Delete Devices');
          console.log(error.error.message);
        }
      );
    } else {
      this.searchTermInvalid = true;
    }
  }

  formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  }
  loadAllCountryCode() {
    const countryData = Country.getAllCountries();
    this.countryCodes = countryData.map((country) => ({
      name: country.name,
      dial_code: country.phonecode,
      code: country.isoCode,
    }));
  }

  preventInput(event: KeyboardEvent): void {
    event.preventDefault();
  }

  onConsumerIDChange() {
    let consumerID = this.consumerID.trim();
    if (consumerID.length >= 3) {
      this.deviceService.getMatchingConsumerIDs(consumerID).subscribe(
        (response) => {
          if (response.data && response.data.devices) {
            this.matchingConsumerIDs = response.data.devices.map(
              (device: { consumer_id: string }) => device.consumer_id
            );
          } else {
            this.matchingConsumerIDs = [];
          }
        },
        (error) => {
          console.error('Error fetching matching Consumer IDs:', error);
        }
      );
    } else {
      this.matchingConsumerIDs = [];
    }
  }

  selectConsumerID(id: string) {
    this.consumerID = id;
    this.matchingConsumerIDs = [];
    this.getDevice(id);
  }
  oncancel = (): void => {
    this.router.navigateByUrl('/home');
  };
  onSubmit(frm: NgForm): void {
    let credential = frm.value;
    let clause = {
      id: this.loggedUser.project_manager_id,
      token: credential.token,
    };
    this.spinner.show();
    this.userService.verifySecurityToken(clause).subscribe(
      (response) => {
        $('#securityTokenConfirmation').modal('hide');
        frm.resetForm();
        this.spinner.hide();
        if (response.data) {
          if (this.functionName == 'addupdatedevice') {
            this.addUpdateDevice(this.addEditDeviceBody);
          } else if (this.functionName == 'deleteDEviceByZone') {
            this, this.deleteDEviceByZoneFUnction();
          } else if (this.functionName == 'deleteDevice') {
            this.deleteDevice(this.addEditDeviceBody);
          } else if (this.functionName == 'deleteDeviceByFile') {
            this.deleteDeviceByFileFuncion();
          }
        } else {
          this.validToken = false;
        }
      },
      (error) => {
        $('#securityTokenConfirmation').modal('hide');
        this.spinner.hide();
        console.error(error);
        frm.resetForm();
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Add/Modify Devices');
      }
    );
  }
}
